/**
 * @generated SignedSource<<caa86ba0194d4a38716a03fa3e34bc69>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentType": "dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer";
};
export type dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraDateTimePickerField"
};

(node as any).hash = "3e67b2e6fb0f14ced5c69254cfab5c08";

export default node;
